import { Link } from 'react-router-dom';
import './pages.css';

const Removable = () => {
    const products = [
            { name: 'Cast Partial', path: '/products/removable/castpartial', image: '/images/removable/castpartial.webp' },
            { name: 'Complete Denture', path: '/products/removable/complete', image: '/images/removable/complete.webp' },
            { name: 'Economy Acrylic Partial', path: '/products/removable/economyacrylicpartial', image: '/images/removable/economyacrylicpartial.webp' },
            { name: 'Economy denture', path: '/products/removable/economydenture', image: '/images/removable/economydenture.webp' },
            { name: 'Valplast® Cast Combo Partial', path: '/products/removable/valplastcastcombopartial', image: '/images/removable/valplastcastcombopartial.webp' },
            { name: 'Valplast® Flexible Partial', path: '/products/removable/valplastflexiblepartial', image: '/images/removable/valplastflexiblepartial.webp' }
        ];
    
    return (
        <div className="page fixed">
            {/* Hero Section */}
            <section className="products-hero-section">
                <div className="products-hero-content">
                    <h1>Removable Prosthetics</h1>
                    <p className="products-tagline">Flexible and comfortable dental solutions</p>
                </div>
            </section>

            {/* Main Content */}
            <section className="products-content-section">
                <div className="content-container">
                    {/* Intro Card */}
                    <div className="products-intro-card">
                        <p>
                            The removable solutions form AbELab are sure to satisfy your edentulous and partially edentulous patients’ needs. With durability and unparalleled esthetics, every option will help to preserve oral health, renew your patient’s confidence, and provide lifelike function.
                        </p>
                    </div>

                    {/* Products Grid */}
                    <div className="products-grid-enhanced">
                        {products.map((product, index) => (
                            <Link to={product.path} key={index} className="product-card-enhanced">
                                <div className="product-image-wrapper">
                                    <img src={product.image} alt={product.name} />
                                </div>
                                <div className="product-info">
                                    <h3>{product.name}</h3>
                                    <span className="learn-more">Learn More →</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Removable;